import _ from '@lodash';
import * as Actions from '../Actions/DocumentoAtendimentoActions';

const initialState = {
    data: null,
    error: null,
    clock: null,
};

const DocumentoAtendimentoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_DOCUMENTOATENDIMENTO:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.DOCUMENTOATENDIMENTO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        case Actions.CHECK_TOKEN:
            {
                return {
                    ...state,
                    clock: action.payload,
                };
            }

        default:
            {
                return state;
            }
    }
};

export default DocumentoAtendimentoReducer;
